var bind = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

var utils = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
var buildURL = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

var InterceptorManager_1 = InterceptorManager;

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
var transformData = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};

var isCancel = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};

var normalizeHeaderName = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};

/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
var enhanceError = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
var createError = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
var settle = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};

/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
var isAbsoluteURL = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
var combineURLs = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
var buildFullPath = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
var parseHeaders = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};

var isValidXss = function isValidXss(requestURL) {
  var xssRegex = /(\b)(on\w+)=|javascript|(<\s*)(\/*)script/gi;
  return xssRegex.test(requestURL);
};

var isURLSameOrigin = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (isValidXss(url)) {
          throw new Error('URL contains XSS injection attempt');
        }

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);

var cookies = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);

var xhr = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies$1 = cookies;

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies$1.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = xhr;
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = xhr;
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

var defaults_1 = defaults;

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
var dispatchRequest = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults_1.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
var mergeConfig = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager_1(),
    response: new InterceptorManager_1()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

var Axios_1 = Axios;

/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

var Cancel_1 = Cancel;

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel_1(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

var CancelToken_1 = CancelToken;

/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
var spread = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios_1(defaultConfig);
  var instance = bind(Axios_1.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios_1.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults_1);

// Expose Axios class to allow class inheritance
axios.Axios = Axios_1;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = Cancel_1;
axios.CancelToken = CancelToken_1;
axios.isCancel = isCancel;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = spread;

var axios_1 = axios;

// Allow use of default import syntax in TypeScript
var default_1 = axios;
axios_1.default = default_1;

var axios$1 = axios_1;

/**
 * Created by Bartosz Wróbel <bartosz.wrobel@softgames.de> on 2019-05-14.
 * Copyright © Softgames 2019 - present
 */

/**
 * @class
 *
 * @description General Game Backend Client error class
 *
 * @property {ERROR_CODE} code Error code
 * @property {mixed} [parentError] Error which caused this error
 *
 * @extends Error
 * @memberof module:error
 */
class A2UError extends Error {
  /**
   * @constructor
   * @param {ERROR_CODE} code Error code
   * @param {string} message Descriptive text of the error
   * @param {mixed} [parentError=] Error that was causing this error
   */
  constructor(code, message, parentError) {
    super(message);
    this.code = code;
    this.parentError = parentError;
    this.thisFileName = this.fileName;
    this.thisLineNumber = this.lineNumber;
    this.thisColumnNumber = this.columnNumber;
  }

  toString() {
    try {
      const code = this.code || 'No error code';
      const msg = this.message || 'No error message';
      const file = this.thisFileName;
      const line = this.thisLineNumber;
      const column = this.thisColumnNumber;
      const detailParts = [
        file ? `file: ${file}` : null,
        line ? `line: ${line}` : null,
        column ? `column: ${column}` : null,
      ].filter(e => !!e);
      const details = detailParts.length
        ? ` [[${detailParts.join(' ')}]]]`
        : '';
      let parentString = null;
      if (this.parentError) {
        parentString =
          typeof this.parentError.toString === 'function'
            ? this.parentError.toString()
            : 'Parent error does not have a toString function';
      }
      let stackString = null;
      if (this.stack) {
        stackString =
          typeof this.stack.toString === 'function'
            ? this.stack.toString()
            : 'Stack does not have a toString function';
      }
      const parentPart = parentString
        ? `with parent error:\n${parentString}`
        : `with stack:\n${stackString || 'No stack available'}`;
      return `A2UError: [${code}] ${msg}${details} ${parentPart}`;
    } catch (error) {
      return `Failed to execute toString on error due to error: ${error}`;
    }
  }

  get fileName() {
    return this.parentError
      ? this.parentError.fileName
      : this.thisFileName || 'unknown';
  }

  get lineNumber() {
    return this.parentError
      ? this.parentError.lineNumber
      : this.thisLineNumber || 'n/a';
  }

  get columnNumber() {
    return this.parentError
      ? this.parentError.columnNumber
      : this.thisColumnNumber || 'n/a';
  }
}

/**
 * Created by René Simon <rene.simon@softgames.de> on 2019-05-27.
 * Copyright © Softgames 2019 - present
 */

/**
  * @constant ERROR_CODE
  * @type {Object}
  * @property {String} UNKNOWN unknown error
  * @property {String} INVALID_PARAMETER Identify that input parameters validation has failed.
  * @property {String} NOT_AUTHORIZED Identify that authorization failed.
  * @property {String} BAD_REQUEST Identify that input parameters were invalid.
  * @property {String} INTERNAL_SERVER_ERROR Identify that the server have failed.

  *
  * @memberof module:enums
  */
const ERROR_CODE = {
  UNKNOWN: 'Unknown',
  INVALID_PARAMETER: 'InvalidParameter',
  NOT_AUTHORIZED: 'NotAuthorized',
  BAD_REQUEST: 'BadRequest',
  INTERNAL_SERVER_ERROR: 'InternalServerError',
};

/**
 * Created by Bartosz Wróbel <bartosz.wrobel@softgames.de> on 2019-05-14.
 * Copyright © Softgames 2019 - present
 */

/**
 * @class
 *
 * @description  Validation error class. When function parameters validation will fail.
 *
 * @property {mixed} validExample A valid example for the property that is invalid
 *
 * @extends A2UError
 * @memberof module:error
 */
class A2UErrorValidationFailed extends A2UError {
  /**
   * @constructor
   * @param {string} message Descriptive text of the error
   * @param {mixed} validExample A valid example for the property that is invalid
   */
  constructor(message, validExample) {
    super(ERROR_CODE.INVALID_PARAMETER, message);
    this.validExample = validExample;
  }

  /**
   * @description
   * Returns the valid example given on construction
   *
   * @return {mixed}
   */
  getValidExample() {
    return this.validExample;
  }
}

/**
 * Created by René Simon<rene.simon@softgames.de> on 2019-07-19.
 * Copyright © Softgames 2019 - present
 */

/**
 * @class
 *
 * @description  Unknown error
 *
 * @extends A2UError
 * @memberof module:error
 */
class A2UUnknownError extends A2UError {
  /**
   * @constructor
   * @param {string} message Descriptive text of the error
   * @param {mixed} [parentError=] Error that was causing this error
   */
  constructor(message, parentError) {
    super(ERROR_CODE.UNKNOWN, message, parentError);
  }
}

/**
 * Created by René Simon<rene.simon@softgames.de> on 2019-07-19.
 * Copyright © Softgames 2019 - present
 */

/**
 * @class
 *
 * @description  Identify problem with not authorized request to the game backend. For example when invalid authToken will be used for login method.
 *
 * @extends A2UError
 * @memberof module:error
 */
class A2UNotAuthorizedError extends A2UError {
  /**
   * @constructor
   * @param {string} message Descriptive text of the error
   * @param {mixed} [parentError=] Error that was causing this error
   */
  constructor(message, parentError) {
    super(ERROR_CODE.NOT_AUTHORIZED, message, parentError);
  }
}

/**
 * @typedef {Object} HttpErrorOptions
 * @property {number} [status] HTTP Status code
 * @property {string} [url] The url of the request
 * @property {Object} [data] Either body or params
 * @property {mixed} [additionalInformation] Error that was causing this error
 * @property {mixed} [parentError] Error that was causing this error
 */

/**
 * @class
 *
 * @description  Identify problem with the API request.
 *
 * @property {number} [status] HTTP Status code
 * @property {string} [url] The url of the request
 * @property {Object} [data] Either body or params
 * @property {mixed} [additionalInformation] Error that was causing this error
 *
 * @extends A2UError
 * @memberof module:error
 */
class A2UHttpError extends A2UError {
  /**
   * @constructor
   * @param {ERROR_CODE} code Error code
   * @param {string} message Descriptive text of the error
   * @param {HttpErrorOptions} [options=]
   */
  constructor(
    code,
    message,
    { status, url, data, additionalInformation, parentError } = {}
  ) {
    super(code, message, parentError);
    this.status = status;
    this.url = url;
    this.data = data;
    this.additionalInformation = additionalInformation;
  }
}

/**
 * @class
 *
 * @description Identify problem with the request sent to the API server. For example when the signature is invalid or the game is not whitelisted.
 *
 * @extends A2UHttpError
 * @memberof module:error
 */
class A2UBadRequestError extends A2UHttpError {
  /**
   * @constructor
   * @param {string} message Descriptive text of the error
   * @param {HttpErrorOptions} options
   */
  constructor(message, options) {
    super(ERROR_CODE.BAD_REQUEST, message, options);
  }
}

/**
 * @class
 *
 * @description Identify problem with the API server. For example when the database instance is down.
 *
 * @extends A2UHttpError
 * @memberof module:error
 */
class A2UInternalServerError extends A2UHttpError {
  /**
   * @constructor
   * @param {string} message Descriptive text of the error
   * @param {HttpErrorOptions} options
   */
  constructor(message, options) {
    super(ERROR_CODE.INTERNAL_SERVER_ERROR, message, options);
  }
}

function createAxios({ baseUrl }) {
  const client = axios$1.create({ baseURL: baseUrl });
  return async ({ method, path, body, params, headers }) => {
    try {
      const { data } = await client.request({
        method,
        url: path,
        data: body,
        params,
        headers,
      });
      return data;
    } catch (error) {
      const { message, response, request } = error;
      if (response) {
        const {
          status = 666,
          data: {
            message: serverMessage = 'Unknown server response',
            additionalInformation = {},
          } = {},
        } = response;
        const { responseURL: targetUrl = path } = request || {};
        if (status === 401) {
          throw new A2UNotAuthorizedError(message);
        }
        const errorType = String(status)[0];
        if (errorType === '4') {
          throw new A2UBadRequestError(message, {
            status,
            targetUrl,
            data: body || params || {},
            parentError: error,
            additionalInformation,
          });
        }
        if (errorType === '5') {
          throw new A2UInternalServerError(message, {
            status,
            targetUrl,
            data: body || params || {},
            parentError: error,
            additionalInformation,
          });
        }
        throw new A2UUnknownError(
          `Server "${targetUrl}" responded with status code "${status}": ${serverMessage}`,
          error
        );
      } else if (request) {
        throw new A2UUnknownError('No server response', error);
      } else {
        throw new A2UUnknownError(
          `Failed to execute request: ${message}`,
          error
        );
      }
    }
  };
}

let clientRequest;

const createAxiosClient = (url = 'https://a2u.softgames.de') => {
  clientRequest = createAxios({ baseUrl: url });
};

const create = ({
  tag,
  messageBody,
  gameId,
  signature,
  receiverId,
  time,
  expireTime,
}) => {
  const body = {
    tag,
    receiverId,
    time,
    ...(expireTime && {
      expireTime,
    }),
    payload: {
      ...messageBody,
      ...(messageBody.payload && {
        payload: JSON.stringify(messageBody.payload),
      }),
      params: JSON.stringify(messageBody.params || {}),
    },
  };

  const requestOptions = {
    method: 'post',
    path: '/api/v1/notification',
    body,
    headers: {
      Authorization: signature,
      gameId,
    },
  };
  return clientRequest(requestOptions);
};

const deleteMessage = ({ tag, receiverId, gameId, signature }) => {
  const requestOptions = {
    method: 'delete',
    path: `/api/v1/notification`,
    params: {
      ...(receiverId ? { receiverId } : {}),
      ...(tag ? { tag } : {}),
    },
    headers: {
      Authorization: signature,
      gameId,
    },
  };
  return clientRequest(requestOptions);
};

/**
 * Created by René Simon <rene.simon@softgames.de> on 2019-11-26.
 * Copyright © Softgames 2019 - present
 */

function isNonEmptyString(str) {
  return !!str && typeof str.valueOf() === 'string' && !!str.trim();
}

function isPlainObject(obj) {
  return !!obj && Object.prototype.toString.call(obj) === '[object Object]';
}

function isDate$1(obj) {
  return !!obj && obj instanceof Date;
}

function isFunction$1(func) {
  return !!func && typeof func === 'function';
}

/**
 * Created by René Simon <rene.simon@softgames.de> on 2020-01-17.
 * Copyright © Softgames 2020 - present
 */

/**
 * @memberof module:base
 * @constant SEVERITY
 * @type {Object}
 * @property {Number} DEBUG - -1
 * @property {Number} INFO - 0
 * @property {Number} NOTICE - 1
 * @property {Number} WARN - 2
 * @property {Number} ERROR - 3
 * @property {Number} FATAL - 4
 * @property {Number} DISABLE - 5
 */
const SEVERITY = {
  DEBUG: -1,
  INFO: 0,
  NOTICE: 1,
  WARN: 2,
  ERROR: 3,
  FATAL: 4,
  DISABLE: 5,
};

const allowedSeverities = Object.values(SEVERITY);

function isValidSeverity(severity) {
  return allowedSeverities.includes(severity);
}

function isString$1(str) {
  return typeof str === 'string';
}

function isNonEmptyString$1(str) {
  return !!str && isString$1(str) && !!str.trim();
}

/**
 * Created by René Simon <rene.simon@softgames.de> on 2020-01-17.
 * Copyright © Softgames 2020 - present
 */

const SEVERITY$1 = SEVERITY;

let NAME = null;

const consoleExists =
  typeof console !== 'undefined' &&
  !!console &&
  typeof console.log === 'function';

function getLogFunction(target, ...alternatives) {
  if (typeof console[target] === 'function') {
    return console[target].bind(console);
  }
  if (!alternatives || !alternatives.length) {
    return console.log.bind(console);
  }
  return getLogFunction(...alternatives);
}

function getLog(logLevel) {
  return {
    log:
      !consoleExists || logLevel > SEVERITY$1.INFO
        ? () => {}
        : getLogFunction('info'),
    debug:
      !consoleExists || logLevel > SEVERITY$1.DEBUG
        ? () => {}
        : getLogFunction('debug'),
    info:
      !consoleExists || logLevel > SEVERITY$1.INFO
        ? () => {}
        : getLogFunction('info'),
    notice:
      !consoleExists || logLevel > SEVERITY$1.NOTICE
        ? () => {}
        : getLogFunction('notice', 'info'),
    warn:
      !consoleExists || logLevel > SEVERITY$1.WARN
        ? () => {}
        : getLogFunction('warn', 'notice', 'info'),
    error:
      !consoleExists || logLevel > SEVERITY$1.ERROR
        ? () => {}
        : getLogFunction('error'),
    fatal:
      !consoleExists || logLevel > SEVERITY$1.FATAL
        ? () => {}
        : getLogFunction('fatal', 'error'),
  };
}

let currentLogger = getLog(SEVERITY$1.DISABLE);

/**
 * @memberof module:base
 * @function setLogSeverity
 * @description
 * Sets the  project's severity to log.
 * The given severity and all higher severities are logged.
 *
 * @param {Object} options
 * @param {Number} options.severity - Severity of type SEVERITY
 * @example
 * import { setLogSeverity, SEVERITY } from '@sgorg/fe-logger';
 *
 * setLogSeverity({ severity: SEVERITY.WARN });
 * // After this all warn, error and fatal logs are printed in the console.
 *
 * @returns {void}
 */
function setLogSeverity({ severity } = {}) {
  if (!isValidSeverity(severity)) {
    throw new Error(
      `Severity must be on of ${allowedSeverities.join(
        ', ',
      )}. Suggest to use SEVERITY enum.`,
    );
  }
  currentLogger = getLog(severity);
}

/**
 * @memberof module:base
 * @function init
 * @description
 * Initializes all loggers for the project.
 * Sets the project name and the project's severity to log (see also setLogSeverity).
 *
 * @param {Object} options
 * @param {String} options.name - Name of the logger
 * @param {Number} options.severity - Severity of type SEVERITY
 * @example
 * import { init, SEVERITY } from '@sgorg/fe-logger';
 *
 * init({ name: 'client', severity: SEVERITY.DEBUG });
 *
 * @returns {void}
 */
function init({ name, severity = SEVERITY$1.DISABLE } = {}) {
  if (!isNonEmptyString$1(name)) {
    throw new Error(`Name must be a non empty string`);
  }
  setLogSeverity({ severity });
  NAME = name;
}

function getLogHandler(severity, name) {
  if (typeof currentLogger[severity] !== 'function') {
    throw new Error(
      `There is no log method with name "${severity}" for generating logger "${name}"`,
    );
  }
  return (...args) => {
    try {
      currentLogger[severity](`[${NAME}][${severity}]${name}`, ...args);
    } catch (error) {
      // [RS] Executing a log never generates an error
    }
  };
}

/**
 * @memberof module:base
 * @function getLogger
 * @description
 * Creates a new logger instance. By default all logs are disabled. Check init or setLogSeverity to change that.
 *
 * @param {Object} options
 * @param {String} options.name - Name of the logger
 * @example
 * import { getLogger } from '@sgorg/fe-logger';
 *
 * const log = getLogger({ name: 'utils' });
 *
 * @returns {module:base.Logger}
 */
function getLogger({ name } = {}) {
  if (!isNonEmptyString$1(name)) {
    throw new Error(`Name must be non-empty string`);
  }
  return Object.keys(currentLogger).reduce(
    (m, severity) => ({
      ...m,
      [severity]: getLogHandler(severity, name),
    }),
    {},
  );
}

/**
 * Created by René Simon <rene.simon@softgames.de> on 2020-01-20.
 * Copyright © Softgames 2020 - present
 */

init({
  name: 'A2U-Client',
  severity: SEVERITY$1.INFO,
});

function getLog$1(name) {
  return getLogger({ name });
}

const log = getLog$1('tracking');

const trackEntry = ({ payload, trackingFunc }) => {
  try {
    const { sbsTracking: { origin } = {} } = payload || {};
    if (origin === 'a2u') {
      const { template, tag } = payload.sbsTracking;
      const options = {
        eventName: 'A2U_NPM_ENTRY',
        params: {
          template: isNonEmptyString(template) ? template : 'N/A',
          tag: isNonEmptyString(tag) ? tag : 'N/A',
        },
      };
      try {
        trackingFunc(options);
      } catch (callError) {
        log.error(
          `Failed to track due to an error in the trackingFunc provided by the game`,
          { callParams: options },
          callError
        );
      }
    }
  } catch (error) {
    log.warn(`Tracking failed due to error`, error);
  }
};

const requiredFields = ['templateType', 'media'];

const validateMessage = messageBody => {
  if (!messageBody)
    throw new A2UErrorValidationFailed(`messageBody is a required object`);

  const { params, customMessage, payload } = messageBody;

  requiredFields.forEach(field => {
    if (!isNonEmptyString(messageBody[field])) {
      throw new A2UErrorValidationFailed(
        `${field} must be an not-empty string`
      );
    }
  });

  if (!isPlainObject(params))
    throw new A2UErrorValidationFailed('params must be a JSON object.');

  if (
    customMessage &&
    (!isNonEmptyString(customMessage) || customMessage.length > 300)
  )
    throw new A2UErrorValidationFailed(
      'customMessage must be, at maximum, a 300 character long string.'
    );

  if (
    payload &&
    (!isPlainObject(payload) || JSON.stringify(payload).length > 800)
  )
    throw new A2UErrorValidationFailed(
      'payload must be plain object, at maximum of 800 character long when stringified object.'
    );
};

/**
 * @memberof module:base
 * @function
 * @description
 * Use this method to create a App-to-User Client
 *
 * @param {Object} configuration
 * @param {String} configuration.gameId - The game slug.
 * @param {String} configuration.signature - The FB signature token for the user.
 * @param {Function} configuration.trackingFunc - The wrapped tracking function for the game (e.g. FBInstant.logEvent()).
 * @param {Object} [configuration.payload] - The payload received in the entrypoint (even if it is null).
 * @param {String} [configuration.url] - The URL for the notification server (for testing purposes).
 * @example
 * import createClient from '@sgorg/app-to-user-client';
 *
 * const payload = window.FBInstant.getEntryPointData(); // (You can send it even if the payload is null)
 * const tracking = ({eventName, params}) => {
 *   window.FBInstant.logEvent(eventName, 1, params);
 * };
 * const a2uClient = createClient({
 *    gameId: "test-game",
 *    signature: "CRjMYLOiYVLNXTSfn6iUM_gWFoQsSIrXxa0L5nr",
 *    trackingFunc: tracking,
 *    payload,
 * });
 *
 * @returns {Client}
 *
 * @throws {A2UErrorValidationFailed}
 */
const createClient = ({ gameId, signature, trackingFunc, payload, url }) => {
  if (!isNonEmptyString(gameId)) {
    throw new A2UErrorValidationFailed(
      'gameId must be an not-empty string',
      'game-slug'
    );
  }
  if (!isNonEmptyString(signature)) {
    throw new A2UErrorValidationFailed(
      'signature must be an not-empty string',
      'CRjMYLOiYVLNXTSfn6iUM_gWFoQsSIrXxa0L5nrZ4Gk.eyJhbXndsaw0aG0iOiJITUFDLVNIQTI1NiIsImlzc3VlZF9hdCI6MTU3NTM4NDM4MSwicGxheWVyX2lkIjoiMzI0ODU1ODM0MTgxNzc2MCIsInJlcXVlc3RfcGF5bG9hZCI6bnVsbH0'
    );
  }
  if (!isFunction$1(trackingFunc)) {
    throw new A2UErrorValidationFailed(
      'trackingFunc must be a defined function',
      () => {}
    );
  }
  if (payload && !isPlainObject(payload)) {
    throw new A2UErrorValidationFailed('payload must be a plain object', {
      a: 'a',
      b: true,
      c: 3,
    });
  }
  // ToDo: Add url check

  trackEntry({ payload, trackingFunc });
  createAxiosClient(url);

  /**
   * @memberof module:base
   * @function
   * @description
   * Use this method to create notifications
   *
   * @param {Object} notification
   * @param {String} notification.tag - The message group (used to delete later if needed).
   * @param {String} notification.receiverId - The receiver player ID.
   * @param {Date} notification.time - UTC Date the message should be sent.
   * @param {Date} [notification.expireTime] - UTC Date to expire the message (only require if the message is time bounded).
   * @param {module:base.IMessageBody} notification.messageBody - The notification body.
   * @example
   * // generates the Client with createClient
   *
   * const notification = {
   *  tag: 'test-tag',
   *  receiverId: '123123',
   *  time: new Date(Date.UTC(2019, 11, 4)) // should always be on UTC.
   *  messageBody: {
   *    templateType: 'score_passed',
   *    params: {
   *      player_id: '123123'
   *    },
   *    media: 'someMediaFileURL.com/file.png',
   *  },
   * }
   *
   * client.createNotification(notification);
   *
   * @returns {VoidFunction}
   *
   * @throws {A2UErrorValidationFailed}
   * @throws {A2UNotAuthorizedError}
   * @throws {A2UBadRequestError}
   * @throws {A2UInternalServerError}
   * @throws {A2UUnknownError}
   *
   */

  const createNotification = async ({
    tag,
    receiverId,
    time,
    expireTime,
    messageBody,
  }) => {
    if (!isNonEmptyString(tag))
      throw new A2UErrorValidationFailed(
        'tag must be an not-empty string',
        'reward'
      );
    if (!isNonEmptyString(receiverId))
      throw new A2UErrorValidationFailed(
        'receiverId must be an not-empty string',
        '1231232'
      );
    if (!isDate$1(time))
      throw new A2UErrorValidationFailed(
        'time must be a Date object.',
        new Date()
      );
    if (expireTime && !isDate$1(expireTime)) {
      throw new A2UErrorValidationFailed(
        'expireTime must be a Date object.',
        new Date()
      );
    }
    validateMessage(messageBody);
    await create({
      tag,
      receiverId,
      messageBody,
      gameId,
      signature,
      time,
      expireTime,
    });
  };

  /**
   * @memberof module:base
   * @function
   * @description
   * Use this method to delete notifications
   *
   * @param {Object} options
   * @param {String} [options.tag] - The message group.
   * @param {String} [options.receiverId] - The receiver playerId.
   * @example
   * // generates the Client with createClient
   *
   * client.deleteNotification({ tag: 'test-tag', receiverId: '123321' });
   *
   * @returns {VoidFunction}
   *
   * @throws {A2UErrorValidationFailed}
   * @throws {A2UNotAuthorizedError}
   * @throws {A2UBadRequestError}
   * @throws {A2UInternalServerError}
   * @throws {A2UUnknownError}
   */

  const deleteNotification = async ({ tag, receiverId }) => {
    await deleteMessage({
      tag,
      receiverId,
      gameId,
      signature,
    });
  };

  return {
    createNotification,
    deleteNotification,
  };
};

export { createClient };
